import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {PostOdontoProviders} from 'domain/usecases/private/booking-flow/odonto/post-odonto-providers';
import {RemotePostOdontoProviders} from 'data/usecases/private/booking-flow/odonto/remote-post-odonto-providers';

export const makePostOdontoProviders = (): PostOdontoProviders =>
	new RemotePostOdontoProviders(
		makeBFFApiUrl(BookingFlowEndPoints.odontoProviders),
		makeAuthorizeHttpClientDecorator(),
	);
